// extracted by mini-css-extract-plugin
export default {"main":"eba-z"};